import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { SharedImport } from "src/app/dtos/import-wizard/shared-imports/shared-imports.dto";
import { firstValueFrom } from "rxjs";
import { SharedImportsService } from "src/app/pages/shared-imports/shared-imports.service";

export const SharedImportLinkGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const sharedImportsService = inject(SharedImportsService);

  const sharedImportId = route.paramMap.get("shared_import_id");
  if (!sharedImportId) {
    return router.createUrlTree(["/"]);
  }

  const sharedImport = await retrieveSharedImport(sharedImportId, sharedImportsService);
  return verifySharedImportLink(sharedImport, route, router);
};

const verifySharedImportLink = (
  sharedImport: SharedImport | null,
  route: any,
  router: Router
) => {
  if (!sharedImport || sharedImport.deactivation != null) {
    const sharedImportId = route.paramMap.get("shared_import_id");
    return router.createUrlTree(["/shared/import", sharedImportId, "invalid-link"]);
  }
  return true;
};

const retrieveSharedImport = async (
  id: string,
  sharedImportsService: SharedImportsService
): Promise<SharedImport | null> => {
  try {
    return await firstValueFrom(sharedImportsService.getSharedImport(id));
  } catch (error) {
    return null;
  }
};